import { render, staticRenderFns } from "./Un-Inbound.vue?vue&type=template&id=8a84106c&scoped=true"
import script from "./Un-Inbound.vue?vue&type=script&lang=js"
export * from "./Un-Inbound.vue?vue&type=script&lang=js"
import style0 from "./Un-Inbound.vue?vue&type=style&index=0&id=8a84106c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a84106c",
  null
  
)

export default component.exports